import { memo } from "react";

import {
  TABS_INDICATOR_CLASS_NAME,
  TABS_INDICATOR_TRANSITION_CLASS_NAME,
} from "@/constants/tabs";
import { useActiveTabIndicator } from "@/hooks/use-active-tab-indicator";
import { cn } from "@/lib/utils";

import type { ITabsIndicatorProps } from "./types";

// NOTE: NSAI-7001 — the brand pill that slides behind the active tab of every
// tab row, the motion the AI Call Assistant switcher introduced. Decorative:
// the triggers carry the selected state, so it is hidden from assistive tech.
const TabsIndicatorComponent = ({
  listRef,
  activeTabSelector,
}: ITabsIndicatorProps): JSX.Element | null => {
  const { rect, isAnimated } = useActiveTabIndicator({
    listRef,
    activeTabSelector,
  });

  if (!rect) {
    return null;
  }

  return (
    <span
      aria-hidden
      data-testid="tabs-indicator"
      className={cn(
        TABS_INDICATOR_CLASS_NAME,
        isAnimated && TABS_INDICATOR_TRANSITION_CLASS_NAME,
      )}
      style={{
        width: rect.width,
        height: rect.height,
        transform: `translate(${rect.left}px, ${rect.top}px)`,
      }}
    />
  );
};

export const TabsIndicator = memo(TabsIndicatorComponent);
